import { ANALYTICS_SITE_PREFIX } from '../config/google-analytics.mjs';
// Preserve existing event names and project the current safe custom fields.
// Known auth/payment returns also receive sanitized page_location/referrer options.
const tokens = new Set(['method', 'model_key', 'creation_type', 'plan_key', 'billing_cycle',
  'campaign_id', 'slide_id', 'close_reason', 'ack_reason']);
const counts = new Set(['dismiss_count', 'dismiss_count_cap']);
export function safeGAParameters(params = {}) {
  const safe = {};
  for (const [key, value] of Object.entries(params || {})) {
    if (tokens.has(key) && typeof value === 'string' && /^[A-Za-z0-9_.-]{1,100}$/.test(value)) safe[key] = value;
    if (counts.has(key) && Number.isSafeInteger(value) && value >= 0) safe[key] = value;
    if (key === 'path' && typeof value === 'string' && /^\/(?!\/)[^?#\s]{0,499}$/.test(value)) safe[key] = value;
  }
  return safe;
}

export function returnAnalyticsOptions(href, referrer) {
  let url; try { url = new URL(href); } catch { return {}; }
  let returnHost = ''; try { returnHost = new URL(referrer).hostname; } catch { /* Empty referrer. */ }
  const providerReturn = ['accounts.google.com', 'checkout.stripe.com', 'billing.stripe.com'].includes(returnHost);
  const returned = providerReturn
    || url.pathname.endsWith('/checkout/success') || url.searchParams.has('auth_success')
    || url.searchParams.has('top_up_success');
  for (const key of ['code', 'session_id', 'auth_success', 'require_invite', 'redirect', 'email', 'prompt', 'token']) url.searchParams.delete(key);
  url.hash = '';
  return { page_location: url.href, ...(returned ? { ignore_referrer: true } : {}),
    ...(providerReturn ? { page_referrer: 'https://' + returnHost + '/' } : {}) };
}
export function canReportOAuthLogin(method, status) {
  return ['google_oauth', 'apple_oauth'].includes(method) && status?.authenticated === true
    && status.guest !== true && status.isActive !== false && status.user?.isActive !== false;
}


export function safePurchaseParameters(params) {
  if(!params||!new RegExp(`^${ANALYTICS_SITE_PREFIX}:(in|pi)_[A-Za-z0-9]+$`).test(params.transaction_id)
    ||!['USD','EUR','GBP','JPY','KRW'].includes(params.currency)||!Number.isFinite(params.value)||params.value<=0
    ||!Number.isFinite(params.tax)||params.tax<0||!['subscription_start','subscription_upgrade','top_up'].includes(params.purchase_type)) return null;
  const item=params.items?.[0];
  if(!Array.isArray(params.items)||params.items.length!==1||!['subscription','credit_top_up'].includes(item?.item_id)||item.price!==params.value||item.quantity!==1) return null;
  return {transaction_id:params.transaction_id,currency:params.currency,value:params.value,tax:params.tax,purchase_type:params.purchase_type,
    items:[{item_id:item.item_id,price:item.price,quantity:1}]};
}
export function analyticsExplicitlyDenied(browser,tagId){
  if(browser?.['ga-disable-'+tagId]===true) return true;
  let storage;
  for(const command of browser?.dataLayer||[]){
    if(command?.[0]==='consent'&&['default','update'].includes(command[1])&&['granted','denied'].includes(command[2]?.analytics_storage)) storage=command[2].analytics_storage;
  }
  return storage==='denied';
}
